/* eslint-disable no-param-reassign */
import { SortOrder } from 'antd/es/table/interface';
import { useImmer } from 'use-immer';
import { getParamFromUrl } from '@/infrastructure/history';

export type IssueSortOrder = 'desc' | 'asc';

export interface IssueSorterItem {
  field?: string;
  sort?: IssueSortOrder;
  antdSort: SortOrder;
}

export enum IssueSorterColumn {
  UploadTime = 'lastReportTime',
  CrashCount = 'docCount',
  ImeiCount = 'qimeiCount',
  // 对比模式上报变化量
  DocCountVariation = 'docCountVariation',
  issuesDocCountPerDevice = 'issuesDocCountPerDevice'
}

const sortToAntdSorter = (sort: IssueSortOrder): SortOrder => (sort ? `${sort}end` : null);

const antdSortToSort = (sort: SortOrder): IssueSortOrder => sort?.slice(0, -3) as IssueSortOrder ?? null;

export function useSorter(): [IssueSorterItem, (fieldName: IssueSorterColumn, sort: SortOrder) => void] {
  const initSortField = getParamFromUrl('sortField') || IssueSorterColumn.UploadTime;
  const initSortOrder = getParamFromUrl('sortOrder') as IssueSortOrder || 'desc';
  const [sorter, updateSorter] = useImmer<IssueSorterItem>({
    field: initSortField,
    sort: initSortOrder,
    antdSort: sortToAntdSorter(initSortOrder),
  });

  const handleSorterUpdate = (fieldName: IssueSorterColumn, sort: SortOrder) => {
    const normalSort = antdSortToSort(sort);
    updateSorter((draft) => {
      draft.field = sort ? fieldName : undefined;
      draft.sort = normalSort;
      draft.antdSort = sort;
    });

    // redirectToNewSearchParams({
    //   sortField: fieldName,
    //   sortOrder: normalSort,
    // });
  };

  return [sorter, handleSorterUpdate];
}
